<template>
    <m-pageframe
        :title="title"
    >
        <m-search-saved-messages-ctrl
            v-on:send-and-edit="$emit('send-and-edit', $event)"
            v-on:send="$emit('send', $event)"
            :include_send="false"
            :include_send_and_edit="false"
            :is_full_page="true"
            :organization_id="this.$rc.$state.profile.employee_account.organization_id"
            v-on:click-introductions="onClickIntroductions"
        />
    </m-pageframe>
</template>

<script>

export default {
    methods: {
        onClickIntroductions()
        {
            this.closeDialog();
            this.$emit('click-introductions');
        },
    },

    computed: {
        title() {
            return this.$rc.$state.profile.organization_account.label + " Saved Messages";
        }
    }
}
</script>

<style lang="scss" scoped>

</style>